<template>
  <div class="enterprise-list">
    <div v-if="isWx">
      <div class="title">请选择您要登录的企业</div>
      <div class="explain">您在企业码中加入了以下企业</div>
      <van-address-list
        class="address_list"
        v-model="chosenAddressId"
        :list="list"
        disabled-text=""
        @add="onAdd"
        @select="onEdit"
        add-button-text="确认"
      />
    </div>
    <div class="wx-is" v-else>请使用微信扫码</div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant'
import { getLocalStorage, getQueryString } from '@utils'
import { getEntByOpenId } from '@api/lishui/interactionForm'
export default {
  data() {
    return {
      chosenAddressId: '',
      list: [],
      creditCode: '',
      mobile: '',
      isWx: true
    }
  },
  mounted() {
    console.log('环境', this.getIsWxClient())

    if (this.getIsWxClient()) {
      // 正式环境
      console.log(process.env.NODE_ENV)

      if (process.env.NODE_ENV !== 'development') {
        const codeKey = getQueryString('code')
        console.log(codeKey)

        // const codeKey = 'osXvn5wYf7g504L4yMEwMjthiAnQ'
        // console.log(codeKey)
        if (codeKey) {
          this.enterList(codeKey)
        } else {
          this.wxGrant()
        }
      }
    } else {
      this.isWx = false
    }
  },
  methods: {
    onAdd() {
      console.log(window.location.href)
      console.log(window.location.href.includes('8420'))
      console.log(process.env.NODE_ENV)
      let FORM_IP // 流程
      if (process.env.NODE_ENV === 'development') {
        // 本地
        FORM_IP = `http://${window.location.hostname}:8561`
      } else if (window.location.href.includes('8824')) {
        // 测试
        FORM_IP = 'http://10.1.1.124:8420' // 表单
      } else {
        // 线上
        // FORM_IP = 'https://lsqym-form.yscredit.com' // 表单
        FORM_IP = 'https://qym.jxj.lishui.gov.cn:8302' // 表单
        // http://58.51.61.130:8530
      }
      if (this.mobile && this.mobile != '') {
        window.location.href =
          FORM_IP +
          '/authorizationMobile.html?formId=' +
          this.$route.query.formId +
          '&creditCode=' +
          this.creditCode +
          '&mobile=' +
          this.mobile
      } else {
        Toast('请选择企业')
      }
    },
    onEdit(item, index) {
      this.mobile = item.mobile
      this.creditCode = item.address
    },
    // 企业列表
    enterList(id) {
      console.log('di', this.$route.query.formId)

      getEntByOpenId({ code: id, formId: this.$route.query.formId }).then(
        res => {
          const { code, data, msg } = res.data
          if (code === '0000') {
            if (data && data.length > 0) {
              this.list = data.map((value, index) => {
                return {
                  id: index,
                  name: value.entName,
                  tel: '',
                  mobile: value.mobile,
                  address: value.creditCode
                }
              })
            } else {
              console.log(msg)
              if (msg === '1') {
                this.$router.replace({ path: '/interaction/errorPage' })
              } else if (msg === '2') {
                this.$router.replace({ path: '/interaction/errorForm' })
              }
            }
          }
        }
      )
    },
    // 判断微信环境
    getIsWxClient() {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      }
      return false
    },

    wxGrant() {
      const appid = 'wxf52a05d6a1f8beb4'
      const url = window.location.href
      let urls = encodeURIComponent(url)
      window.location.href =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        appid +
        '&redirect_uri=' +
        urls +
        '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
    }
  }
}
</script>

<style scoped lang="scss">
.enterprise-list {
  width: 100%;
  height: 100%;
  overflow: scroll;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #f7f8fa;

  .title {
    font-size: 18px;
    margin: 20px 0 0 20px;
  }
  .explain {
    font-size: 16px;
    margin: 10px 0 0 20px;
    color: #999999;
  }
  .address_list {
    height: auto;
    margin-bottom: 60px;
  }
}
.wx-is {
  font-size: 18px;
  color: #000;
  text-align: center;
  margin-top: 60px;
}
/deep/.van-icon-edit {
  display: none;
}
/deep/.van-button--danger {
  background-color: #3399ff;
  border: 1px solid #3399ff;
  border-radius: 10px;
}
/deep/.van-radio__icon--checked {
  .van-icon-success {
    background-color: #3399ff !important;
    border-color: #3399ff !important;
  }
}
</style>
